import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLanguageByUser } from '@picsart/rc/services/localization';

import fetchRationCards from 'utils/requests/fetchRatioCards';
import generalSlice from 'store/general';
import errorLogger from 'services/errorLogger';
import dataService from 'services/dataService';

function useFetchCardsAndBackgrounds() {
  const { currentLanguage } = useLanguageByUser();
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      const [cards, backgrounds] = await Promise.allSettled([fetchRationCards(), dataService.getCMSBackgrounds(currentLanguage)]);

      if (cards.status === 'fulfilled') {
        dispatch(generalSlice.actions.setRatioCards(cards.value));
      } else {
        errorLogger.trigger(new Error(cards.reason), 'error');
      }

      if (backgrounds.status === 'fulfilled') {
        dispatch(generalSlice.actions.setBackgrounds(backgrounds.value));
      } else {
        errorLogger.trigger(new Error(backgrounds.reason), 'error');
      }
    })();
  }, [dispatch, currentLanguage]);
}

export default useFetchCardsAndBackgrounds;
